import { DOCUMENT, inject } from '@angular/core';
import { BuilderInfoService } from '@portal/builder';

const FAVICON_URLS: (x: string) => Record<string, string> = (app = 'default') => ({
  'iphone-favicon': `assets/favicon/${app}/apple-touch-icon.png`,
  'standard-favicon': `assets/favicon/${app}/favicon-32x32.png`,
  'svg-favicon': `assets/favicon/${app}/favicon.svg`,
  'x-icon': `assets/favicon/${app}/favicon.ico`,
});

const includedApps: string[] = ['Abrod', 'Ardb'];

export function addFaviconsPaths(): void {
  const document: Document = inject(DOCUMENT);
  const appName = inject(BuilderInfoService).settings?.appName;
  const appForPath: string = includedApps.includes(appName) ? appName.toLowerCase() : 'default';

  for (const [key, value] of Object.entries(FAVICON_URLS(appForPath))) {
    const element: HTMLElement = document.getElementById(key);
    element && element.setAttribute('href', value);
  }
}
